/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { Provider as ReduxProvider } from 'react-redux';
import persistStore from 'redux-persist/es/persistStore';
import { PersistGate } from 'redux-persist/integration/react';
import { Router } from 'react-router';
import { StylesProvider, createGenerateClassName } from '@material-ui/styles';
import { node } from 'prop-types';
import configureStore from './state/store';
import Checkout from './app/pages/Checkout/Checkout';
import buildGraphQLClient from './app/gql';
import { AuthProvider } from './state/ducks/Member/ducks/Auth/Plugin/auth';
import fiveORouteHistory from './app/pages/Checkout/FiveORouteHistory';
import FiveOWrapper from './FiveOWrapper';
import { getAccessTokenSafely } from './state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const generateClassName = createGenerateClassName({
    productionPrefix: 'mbp-co',
});

const store = configureStore(window.__INITIAL_STATE__);
const persistor = persistStore(store);

const { fiveOOoverride } = fiveORouteHistory();

// eslint-disable-next-line
const apolloState = (typeof window !== 'undefined' && window.__APOLLO_STATE__) ? window.__APOLLO_STATE__ : null;
const { apolloClient } = buildGraphQLClient({
    initialState: apolloState,
});

function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

const HydrateAuthSession = ({ children }) => {
    const MAX_RETRIES = 10;
    const [token, setToken] = useState(false);
    const [retry, setRetry] = useState(1);
    useEffect(() => {
        async function authCall() {
            const authSessionResponse = await getAccessTokenSafely();
            if (!authSessionResponse && retry <= MAX_RETRIES) {
                await delay(300);
                setRetry(retry + 1);
                console.log('Retrying to fetch session::', retry);
            } else if (authSessionResponse) {
                setToken(authSessionResponse);
                console.log('Session set after::', retry);
            } else {
                console.log('Max Limit reached of retry', retry);
            }
        }
        authCall();
    }, [retry]);

    if (!token) {
        return <div className="loading" />;
    }
    return children;
};

HydrateAuthSession.propTypes = {
    children: node.isRequired,
};

// injectable entry point, delegates rendering to the hub
const CheckoutApp = () => {
    if (apolloClient && store && fiveOOoverride) {
        return (
            <ApolloProvider client={apolloClient}>
                <ReduxProvider store={store}>
                    <FiveOWrapper>
                        <PersistGate loading={null} persistor={persistor}>
                            <Router history={fiveOOoverride}>
                                <AuthProvider>
                                    <HydrateAuthSession>
                                        <StylesProvider generateClassName={generateClassName}>
                                            <Checkout
                                                store={store}
                                                ldClient={{}}
                                                history={fiveOOoverride}
                                            />
                                        </StylesProvider>
                                    </HydrateAuthSession>
                                </AuthProvider>
                            </Router>
                        </PersistGate>
                    </FiveOWrapper>
                </ReduxProvider>
            </ApolloProvider>
        );
    }

    return <div>INJECTED APP</div>;
};

// eslint-disable-next-line
ReactDOM.render(
    <React.StrictMode>
        <CheckoutApp />
    </React.StrictMode>,
    document.getElementById('root'),
);
